import { TextWithLineBreaks } from "@medoma/components/Text/Text";
import { type IExistingPatient } from "@medoma/models/patients";
import styles from "./ImportantInfo.module.scss";
import clsx from "clsx";
import DogIcon from "@medoma/components/icons/DogIcon";
import FlagIcon from "@medoma/components/icons/FlagIcon";
import KeyIcon from "@medoma/components/icons/KeyIcon";

export const ImportantInfo = ({
  patient,
}: {
  patient: Pick<IExistingPatient, "address" | "status" | "flags" | "pet">;
}) => {
  const { additionalInformation, keyToPatient } = patient.address;
  if (
    !additionalInformation &&
    !patient.flags &&
    !keyToPatient &&
    !patient.pet
  ) {
    return null;
  }

  return (
    <div className={styles.infoBoxes}>
      {additionalInformation ? (
        <div className={styles.infoBox}>
          <TextWithLineBreaks>{additionalInformation}</TextWithLineBreaks>
        </div>
      ) : null}
      {keyToPatient ? (
        <div className={clsx(styles.infoBox, styles.keyInfoBox)}>
          <KeyIcon />
          <TextWithLineBreaks>{keyToPatient}</TextWithLineBreaks>
        </div>
      ) : null}
      {patient.pet ? (
        <div className={clsx(styles.infoBox, styles.petInfoBox)}>
          <DogIcon />
          <TextWithLineBreaks>{patient.pet}</TextWithLineBreaks>
        </div>
      ) : null}
      {patient.flags ? (
        <div className={clsx(styles.infoBox, styles.flagsInfoBox)}>
          <FlagIcon />
          <TextWithLineBreaks>{patient.flags}</TextWithLineBreaks>
        </div>
      ) : null}
    </div>
  );
};
